import { ZodType, z } from 'zod';

export type CreateSessionResponse = {
	SessionId: string;
	SessionUrl: string;
	ReturnUrl: string;
};

export const createSessionResponseSchema: ZodType<CreateSessionResponse> = z.object({
	SessionId: z.string(),
	SessionUrl: z.string(),
	ReturnUrl: z.string(),
});
